// Imported FIRST: its top-level reads window.location.* before createClient() below,
// which clears the URL hash during supabase's async init (see authLanding.ts).
import './authLanding.ts';
import { createClient } from '@supabase/supabase-js';

// Public by design — RLS is the security boundary. These VITE_* vars are baked
// into the browser bundle on purpose. The service-role and Anthropic keys are
// NOT here; they live only in Netlify functions.
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Surfaced in dev so a missing-env mistake is obvious, not a blank screen.
  console.error('Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY.');
}

export const supabase = createClient(url ?? '', anonKey ?? '');
